import { Component, ViewChild, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { 
  CircleProgressComponent,
  CircleProgressOptions,
  NgCircleProgressModule } from 'ng-circle-progress';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ScoreService } from '../service/score.service';
import { UserProfileService } from '../service/user-profile.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ThemePalette } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-score-card',
  standalone: true,
  imports: [
    CommonModule, 
    NgCircleProgressModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatFormFieldModule, 
    MatSelectModule,
    RouterLink,
    TranslateModule,
  ],
  providers: [
    (
      NgCircleProgressModule.forRoot(
        {}
      ) as ModuleWithProviders<NgCircleProgressModule>
    ).providers!,
  ],
  templateUrl: './score-card.component.html',
  styleUrl: './score-card.component.css'
})
export class ScoreCardComponent {
  color : ThemePalette = 'accent';
  isLoading = false;
  apexId!:string;
  date = new Date();
  scoreObjectArray!:any[];
  kpiCategoryScoreRankingArray!:any[];
  kpiOverallScoreRankingObject!:any;
  ytdObject!:any;
  categoryRankingArray!:CircleProgressOptions[];
  overallRankingArray!:CircleProgressOptions[];
  
  rangeArray:string[]=['DT', 'Region', 'Country'];
  @ViewChild('circleProgress') circleProgress!: CircleProgressComponent;
  monthTotalScore = 0;
  monthActualScore = 0;
  yearTotalScore = 0;
  yearActualScore = 0;
  yearAverageScore = 0;
  browserLangToUse = '';
  constructor(
    private userProfileService: UserProfileService,
    private scoreService: ScoreService,
    translate: TranslateService,
    private location: Location,
  ) { 
    translate.setDefaultLang('en');
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    translate.use(browserLangToUse);
    this.browserLangToUse = browserLangToUse;
    translate.get(['ml_151127', 'ml_151454']).subscribe((res: any) => {
      console.log(res);
      this.thisYear = res.ml_151127;
      this.lastYear = res.ml_151454;
      this.monthArray = this.getMonthArray();
    });
  }  
  options = new CircleProgressOptions();
  optionsA: CircleProgressOptions = {
    ...this.options,
    percent: 85,
    radius: 60,
    space: -10,
    outerStrokeGradient: true,
    outerStrokeWidth: 10,
    outerStrokeColor: "#4882c2",
    outerStrokeGradientStopColor: "#53a9ff",
    innerStrokeColor: "#e7e8ea",
    innerStrokeWidth: 10,
    title: "UI",
    subtitle: "sub",
    // animateTitle: false,
    // animationDuration: 1000,
    showUnits: false,
    showBackground: false,
    clockwise: false,
    startFromZero: false,
    lazy: true
  };
  copyOptions = (event: any, options: any) => {
    this.options = Object.assign(
      {},
      this.circleProgress.defaultOptions,
      options
    );
  };  
  ngOnInit(): void {
    let date = new Date();
    let startDay = this.getStartDate(date);;
    let formattedStartDayString = this.getFormattedDateString(startDay);
    
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      let apexId = localStorage.getItem("apexid"); 
      this.apexId = apexId!;
      let country = localStorage.getItem("driverCountry")!;
      let businessType = localStorage.getItem("driverBusinessType")!;
      if(apexId !== null){        
        this.pageInitialization(apexId, 'year',formattedStartDayString, country, businessType);
      }      
    }
    else{
      let overrideObject = JSON.parse(overrideObjectString);
      let apexId = overrideObject.apexid;
      this.apexId = apexId;
      let country = overrideObject.driverCountry;
      let businessType = overrideObject.driverBusinessType;
      this.pageInitialization(apexId, 'year',formattedStartDayString, country, businessType);
    }
  }
  private getColor(rank: number, total: number): any {
    let color: any = { startColor: '', endColor: '' };
    if(rank === 1){
      color.startColor = '#03C03C';
      color.endColor = '#32de84';
    }
    else{
      if(rank === total){
        color.startColor = '#BA0021';
        color.endColor = '#FF033E';
      }
      else{
        if (rank < (total / 3)) {
          color.startColor = '#03C03C';
          color.endColor = '#32de84';
        }
        if (rank >= (total / 3)
          && rank < (total / 3 * 2)) {
          color.startColor = '#FFD700';
          color.endColor = '#FFFF00';
        }
        if (rank >= (total / 3 * 2)) {                
          color.startColor = '#BA0021';
          color.endColor = '#FF033E';
        }
      }
    }    
    return color;
  }
  private getPercent(rank: number, total: number): number {
    let percent = 0;
    if(rank === 1){
      percent = 100;
    }    
    else{
      if(rank === total){
        percent = 1;
      }
      else{
        percent = 100 - ( rank / total * 100 );
      }      
    }
    return percent;
  }
  selectedMonth = 'YTD';
  
  monthArray!: any[];
  thisYear = '';
  lastYear = '';
  getMonthArray(): any[] {
    let monthArray: any[] = [];
    let date = new Date();
    monthArray.push({ textValue: 'YTD', textString: this.thisYear });
    monthArray.push({ textValue: 'YTDLY', textString: this.lastYear });
    for (let i = 0; i < 12; i++) {
      // let monthString = date.toISOString()!.split('T')[0].substring(0, 7);
      let monthString = this.convertDateToString(date);
      let arrayObject: any = { textValue: monthString, textString: monthString };
      monthArray.push(arrayObject);
      
      let previousMonth = this.getPreviousMonth(date);
      date = previousMonth;
      
    }
    return monthArray;
  }
  convertDateToString(date: Date):string {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month].join('-');
  }
  getFormattedDateString(dateObject: Date):string{
    const offset = dateObject.getTimezoneOffset()
    dateObject = new Date(dateObject.getTime() - (offset*60*1000))
    return dateObject.toISOString().split('T')[0]
  }
  getPreviousMonth(date: Date): Date {
    const clone = new Date(date);
    clone.setDate(0);
    return clone;
  }
  isYear = true;
  clearValue():void{
    this.monthTotalScore = 0;
    this.monthActualScore = 0;
    this.yearTotalScore = 0;
    this.yearActualScore = 0;
    this.yearAverageScore = 0;
  }
  
  getStartDate(date: Date): Date {
    if( date >= new Date(date.getFullYear(), 9, 1) && date < new Date(date.getFullYear() + 1, 0, 1) ){
      return new Date(date.getFullYear(), 9, 1);
    }  
    else{
      return new Date(date.getFullYear() - 1, 9, 1);
    }
  }

  setMonthAndYearFromSelect(value:any){
    this.clearValue();
    let date = new Date();
    console.log(date);
    if(value.startsWith('YTD')){
      this.isYear = true;
      let startDay = this.getStartDate(date);
      console.log(startDay);
      if(value.startsWith('YTDLY')){
        startDay = new Date(startDay.getFullYear() - 1, 9, 1, 0, 0, 0, 0);
        console.log(startDay);
      }      
      let formattedStartDayString = this.getFormattedDateString(startDay);
      
      let overrideObjectString = localStorage.getItem("overrideObject");
      if(overrideObjectString === null){
        let apexId = localStorage.getItem("apexid"); 
        let country = localStorage.getItem("driverCountry")!;
        let businessType = localStorage.getItem("driverBusinessType")!;
        if(apexId !== null){        
          this.pageInitialization(apexId, 'year',formattedStartDayString, country, businessType);
        }      
      }
      else{
        let overrideObject = JSON.parse(overrideObjectString);
        let apexId = overrideObject.apexid;
        let country = overrideObject.driverCountry;
        let businessType = overrideObject.driverBusinessType;
        this.pageInitialization(apexId, 'year',formattedStartDayString, country, businessType);
      }
    }
    else{
      this.isYear = false;
      
      let overrideObjectString = localStorage.getItem("overrideObject");
      if(overrideObjectString === null){
        let apexId = localStorage.getItem("apexid"); 
        let country = localStorage.getItem("driverCountry")!;
        let businessType = localStorage.getItem("driverBusinessType")!;
        if(apexId !== null){        
          this.pageInitialization(apexId, 'month',value + '-01', country, businessType);
        }      
      }
      else{
        let overrideObject = JSON.parse(overrideObjectString);
        let apexId = overrideObject.apexid;
        let country = overrideObject.driverCountry;
        let businessType = overrideObject.driverBusinessType;
        this.pageInitialization(apexId, 'month',value + '-01', country, businessType);
      }
    }    
  }
  private pageInitialization(apexId:string, timerange:string, formattedDateString:string, country:string, businessType:string): void {
    this.isLoading = true;
    this.scoreService.getScoreMonthOrYear(apexId, formattedDateString, country, businessType, timerange).subscribe(responseScoreObjectArray => {
      this.scoreObjectArray = responseScoreObjectArray;        
      if( this.scoreObjectArray.length === 0 ){
        this.kpiCategoryScoreRankingArray = [];
        this.kpiOverallScoreRankingObject = null;
      }
      else{
        this.kpiCategoryScoreRankingArray = this.scoreObjectArray[0];
        this.kpiOverallScoreRankingObject = this.scoreObjectArray[1];
      }
      this.categoryRankingArray = [];
      
      for (const kpiCategoryScoreRanking of this.kpiCategoryScoreRankingArray){
        let terminalRank = '';
        let terminalRankPercent = 0;
        let categoryNameShort = '';
        let terminalRankouterStrokeColor = '';
        let terminalRankouterStrokeGradientStopColor = '';

        if(kpiCategoryScoreRanking.kpiCategoryItems.length === 0){
          
          terminalRank = '-' + '/' + '-';
          terminalRankPercent = 0;            
          terminalRankouterStrokeColor = '#03C03C';
          terminalRankouterStrokeGradientStopColor = '#32de84'

        }
        else{
          
          terminalRank = kpiCategoryScoreRanking.kpiCategoryItems[0].tRank + '/' + kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal;
          terminalRankPercent = this.getPercent( kpiCategoryScoreRanking.kpiCategoryItems[0].tRank , kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal );            
          if(kpiCategoryScoreRanking.kpiCategoryItems[0].tRank < ( kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal / 3) ){              
            let color = this.getColor(kpiCategoryScoreRanking.kpiCategoryItems[0].tRank, kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal);
            terminalRankouterStrokeColor = color.startColor;
            terminalRankouterStrokeGradientStopColor = color.endColor;
          }
          if(kpiCategoryScoreRanking.kpiCategoryItems[0].tRank >= ( kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal / 3 ) 
              && kpiCategoryScoreRanking.kpiCategoryItems[0].tRank < ( kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal / 3 * 2 ) ){
            let color = this.getColor(kpiCategoryScoreRanking.kpiCategoryItems[0].tRank, kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal);
            terminalRankouterStrokeColor = color.startColor;
            terminalRankouterStrokeGradientStopColor = color.endColor;
          }
          if(kpiCategoryScoreRanking.kpiCategoryItems[0].tRank >= ( kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal / 3 * 2 ) ){            
            let color = this.getColor(kpiCategoryScoreRanking.kpiCategoryItems[0].tRank, kpiCategoryScoreRanking.kpiCategoryItems[0].tTotal);
            terminalRankouterStrokeColor = color.startColor;
            terminalRankouterStrokeGradientStopColor = color.endColor;
          }            
        }
        categoryNameShort = kpiCategoryScoreRanking.translation_Id;
        let newCircleProgressOptions: CircleProgressOptions = {
          ...this.options,
          percent: terminalRankPercent, 
          subtitleFontSize: "20",
          radius: 40,
          space: -10,
          outerStrokeGradient: true,
          outerStrokeWidth: 10,
          outerStrokeColor: terminalRankouterStrokeColor,
          outerStrokeGradientStopColor: terminalRankouterStrokeGradientStopColor,
          innerStrokeColor: "#e7e8ea",
          innerStrokeWidth: 10,
          title: terminalRank,
          subtitle: categoryNameShort,
          // animateTitle: false,
          // animationDuration: 1000,
          showUnits: false,
          showBackground: false,
          clockwise: false,
          startFromZero: false,
          lazy: true
        };          
        this.categoryRankingArray.push(newCircleProgressOptions);
      }

      this.overallRankingArray = [];

      for (const range of this.rangeArray ){

        let rank = '';
        let rankPercent = 0;
        let terminalRankouterStrokeColor = '';
        let terminalRankouterStrokeGradientStopColor = '';
        let radius = 0;
        let rangeString = '';

        if(range === 'DT'){
          radius = 45;
          rangeString = 'ml_144047';
        }
        if(range === 'Region'){
          radius = 50;
          rangeString = 'ml_143911';
        }
        if(range === 'Country'){
          radius = 55;
          rangeString = 'ml_143912';
        }

        if(this.kpiOverallScoreRankingObject === null){
          rank = '-' + '/' + '-';
          rankPercent = 0;            
          terminalRankouterStrokeColor = '#03C03C';
          terminalRankouterStrokeGradientStopColor = '#32de84'
        }
        else{
          this.monthActualScore = 100 + this.kpiOverallScoreRankingObject.score;
          this.yearActualScore = this.kpiOverallScoreRankingObject.totalMonth * 100 + this.kpiOverallScoreRankingObject.score;
          this.monthTotalScore = this.kpiOverallScoreRankingObject.totalScore;
          this.yearTotalScore = this.kpiOverallScoreRankingObject.totalMonth * 100;
          this.yearAverageScore = 100 + ( this.kpiOverallScoreRankingObject.score / this.kpiOverallScoreRankingObject.totalMonth );
          
          
          if(range === 'DT'){
            
            rank = this.kpiOverallScoreRankingObject.tRank + '/' + this.kpiOverallScoreRankingObject.tTotal;
            rankPercent = this.getPercent( this.kpiOverallScoreRankingObject.tRank , this.kpiOverallScoreRankingObject.tTotal );
            let color = this.getColor(this.kpiOverallScoreRankingObject.tRank, this.kpiOverallScoreRankingObject.tTotal);
            terminalRankouterStrokeColor = color.startColor;
            terminalRankouterStrokeGradientStopColor = color.endColor;
            
          }
          if(range === 'Region'){
            
            rank = this.kpiOverallScoreRankingObject.rRank + '/' + this.kpiOverallScoreRankingObject.rTotal;
            rankPercent = this.getPercent( this.kpiOverallScoreRankingObject.rRank , this.kpiOverallScoreRankingObject.rTotal );
            let color = this.getColor(this.kpiOverallScoreRankingObject.rRank, this.kpiOverallScoreRankingObject.rTotal);
            terminalRankouterStrokeColor = color.startColor;
            terminalRankouterStrokeGradientStopColor = color.endColor;
            
          }
          if(range === 'Country'){
            
            rank = this.kpiOverallScoreRankingObject.cRank + '/' + this.kpiOverallScoreRankingObject.cTotal;
            rankPercent = this.getPercent( this.kpiOverallScoreRankingObject.cRank , this.kpiOverallScoreRankingObject.cTotal );
            let color = this.getColor(this.kpiOverallScoreRankingObject.cRank, this.kpiOverallScoreRankingObject.cTotal);
            terminalRankouterStrokeColor = color.startColor;
            terminalRankouterStrokeGradientStopColor = color.endColor;
            
          }
                  
        }

        let newCircleProgressOptions: CircleProgressOptions = {
          ...this.options,
          percent: rankPercent, 
          subtitleFontSize: "20",
          radius: radius,
          space: -10,
          outerStrokeGradient: true,
          outerStrokeWidth: 10,
          outerStrokeColor: terminalRankouterStrokeColor,
          outerStrokeGradientStopColor: terminalRankouterStrokeGradientStopColor,
          innerStrokeColor: "#e7e8ea",
          innerStrokeWidth: 10,
          title: rank,
          subtitle: rangeString,
          
          showUnits: false,
          showBackground: false,
          clockwise: false,
          startFromZero: false,
          lazy: true
        };
        this.overallRankingArray.push(newCircleProgressOptions);  

      }
      
      

      this.isLoading = false;
    });
    
  }
  backClicked() {
    this.location.back();
  }
}
